import React, { useContext } from "react";
import { Typography, Box, AppBar } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import AppContext from "../../context/AppContext";
import { formatDate } from "../../utils/date";
import authService from "../../services/authService";
import CommonHeader from "./CommonHeader";
import styles from "../MainNavigation/MainNavigation.module.css";
import MainNavigation from "../MainNavigation/MainNavigation";

type StandardizedHeaderProps = {
  title: string;
  noTextTransform?: boolean;
};

const StandardizedHeader: React.FC<StandardizedHeaderProps> = (props) => {
  const isDesktop = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  const mobility = authService.isMobility();
  const offsetHeight = !isDesktop || mobility ? 162 : 138;

  const lastlogin: string = authService.getLastLogin();

  const onBack = () => {
    if (location.state) {
      navigate(`/patients${location.state.search}`);
    } else {
      navigate(`/patients`);
    }
  };

  const styledHeader = (title: string): React.ReactElement => {
    return (
      <Typography display="inline" style={{ fontSize: "30px", color: "white" }}>
        {title}
      </Typography>
    );
  };

  return (
    !isDesktop || mobility ? (
      <CommonHeader
        title={props.title}
        noTextTransform={props.noTextTransform}
        onLinkClick={onBack}
        infoBar={
          <Box display="flex" justifyContent="flex-end" flexDirection={isDesktop ? "row" : "column"} width={1}>
            <Box pr={[0, 2]} ml={2}>
              <Typography display="inline" variant="body2" style={{ color: "#c8aee1" }}>
                Last Login:
              </Typography>
              <Typography variant="body2" display="inline">
                &nbsp;&nbsp;
                {formatDate(lastlogin, "DD MMMM YYYY hh:mm A", false)}
              </Typography>
            </Box>
          </Box>
        }
      ></CommonHeader>
    ) : (
      <Box>
        <AppBar elevation={0} className={styles.headerBar}>
          <MainNavigation
            showBackButton
            mainHeader={styledHeader(props.title)}
            backText="PATIENT LIST"
            backPath="/patients"
            hideSeparator={true}
            isHospitalReports
          />
        </AppBar>
        <div className={`${styles.hideForPrinting}`} style={{ height: offsetHeight }} />
      </Box>
    )
  );
};

export default StandardizedHeader;
